module.exports = __webpack_public_path__ + "img/card.48753650.svg";